/* Copyright (c) 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  FilterComparisonOperator,
  PlansFilterByFields,
  useGetCustomActionPlansQuery,
} from "~/generated/graphql";

type Props = {
  customActionId: string;
  skip?: boolean;
};

export function useGetCustomActionPlans({ customActionId, skip }: Props) {
  const { data, loading, error } = useGetCustomActionPlansQuery({
    variables: {
      filter: {
        filterBy: [
          {
            field: PlansFilterByFields.ActionId,
            operator: FilterComparisonOperator.Eq,
            values: [customActionId],
          },
        ],
      },
    },
    skip,
    fetchPolicy: "network-only",
  });
  const count = data?.plans.pageInfo?.count ?? 0;
  const planNames = data?.plans.result?.map(({ name }) => name) ?? [];

  return { planNames, loading, error, count } as const;
}
